define('lq/busyIndicator',[
    'jquery',
    'lq/runtimeBusyIndicator'
], function ($, RuntimeBusyIndicator) {
    'use strict';
    
    return new RuntimeBusyIndicator($('body'));
});

